import styled from 'styled-components';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';

export const StyledAccountSettingsContainer = styled(StyledContainer)`
    background: white;
    margin-bottom: 20px;
`;
